"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWordCount = void 0;
function getWordCount(content) {
    return content.split(/\s+/).length;
}
exports.getWordCount = getWordCount;
